import { render, staticRenderFns } from "./FacsimileViewer.vue?vue&type=template&id=630d8f59"
import script from "./FacsimileViewer.vue?vue&type=script&lang=js"
export * from "./FacsimileViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports